import { t } from "@/i18n";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Coins, Loader2, Star } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const COLORS = { starter: "bg-[#4ECDC4]", classroom: "bg-[#FFD166]", school: "bg-[#FF9FF3]" };

export default function Credits() {
  const { user } = useAuth();
  const [packs, setPacks] = useState([]);
  const [busy, setBusy] = useState(null);

  useEffect(() => {
    api.get("/payments/packs").then((r) => setPacks(r.data));
  }, []);

  const buy = async (id) => {
    setBusy(id);
    try {
      const { data } = await api.post("/payments/checkout", { pack_id: id, origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error(formatApiError(e));
      setBusy(null);
    }
  };

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-12" data-testid="credits-page">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-12 rise">
        <div>
          <h1 className="text-4xl sm:text-5xl font-bold tracking-tight">{t("credit_packs")}</h1>
          <p className="text-slate-600 mt-2 text-base sm:text-lg">{t("one_time_purchase_1_credit_1_colouring_p")}</p>
        </div>
        <span className="credit-badge text-base" data-testid="credits-page-balance"><Coins className="w-5 h-5" /> {user.credits} credits left</span>
      </div>
      <div className="grid md:grid-cols-3 gap-8">
        {packs.map((p, i) => (
          <div key={p.id} data-testid={`pack-card-${p.id}`}
            className={`relative bg-white rounded-3xl p-8 border-4 ${p.popular ? "border-[#1E293B] shadow-[8px_10px_0_0_#1E293B] md:-translate-y-3" : "border-slate-200"} flex flex-col gap-6 rise d${i + 1}`}>
            {p.popular && <span className="absolute -top-4 left-8 bg-[#FF5252] text-white text-xs font-bold px-3 py-1.5 rounded-full flex items-center gap-1"><Star className="w-3 h-3" /> {t("teachers_favourite")}</span>}
            <div className={`w-14 h-14 rounded-2xl ${COLORS[p.id]} border-2 border-[#1E293B] flex items-center justify-center`}><Coins className="w-7 h-7" /></div>
            <div>
              <h3 className="font-display text-2xl font-semibold">{p.name}</h3>
              <p className="text-slate-500">{p.tagline}</p>
            </div>
            <div>
              <p className="font-display text-5xl font-bold">{p.credits}<span className="text-lg text-slate-500 font-medium ml-2">{t("credits")}</span></p>
              <p className="text-slate-600 mt-1"><span className="font-bold text-xl text-[#1E293B]">${p.price.toFixed(2)}</span> · ${(p.price / p.credits).toFixed(2)} per page</p>
            </div>
            <button className={`btn-pop ${p.popular ? "btn-red" : "btn-ink"} mt-auto`} disabled={!!busy} onClick={() => buy(p.id)} data-testid={`buy-pack-${p.id}`}>
              {busy === p.id && <Loader2 className="w-5 h-5 animate-spin" />} Buy {p.name}
            </button>
          </div>
        ))}
      </div>
      <p className="text-sm text-slate-500 mt-10 text-center">{t("secure_checkout_by_stripe_test_mode_use_")}</p>
    </div>
  );
}
